// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DialogPopup_paper__17-7M {
  min-width: 450px;
  max-width: 650px !important;
  overflow: visible;
  min-height: 100px;
  background-color: var(--color-bg-popup) !important;
  color: var(--color-font-10) !important;
}

.DialogPopup_paper_big__P5tnN {
  min-width: 1000px;
  max-width: 1000px !important;
  overflow: visible;
  min-height: 100px;
  background-color: var(--color-bg-popup) !important;
  color: var(--color-font-10) !important;
}

.DialogPopup_paper__17-7M::-webkit-scrollbar {
  width: 8px !important;
  display: inherit !important;
  background-color: white !important;
}

.DialogPopup_paper__17-7M::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 0px !important;
  display: inherit !important;
  width: 10px !important;
}
.DialogPopup_paper_big__P5tnN::-webkit-scrollbar {
  width: 8px !important;
  display: inherit !important;
  background-color: white !important;
}

.DialogPopup_paper_big__P5tnN::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 0px !important;
  display: inherit !important;
  width: 10px !important;
}

.DialogPopup_popup_header__epE\\+i {
  text-transform: uppercase;
  padding: 15px;
  font-size: 18px;
  font-weight: bold;
  background-color: var(--color-bg-popup-header);
}

.DialogPopup_popup_content__-xqz7 {
  padding: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/DialogPopup/DialogPopup.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,kDAAkD;EAClD,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,kDAAkD;EAClD,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf","sourcesContent":[".paper {\n  min-width: 450px;\n  max-width: 650px !important;\n  overflow: visible;\n  min-height: 100px;\n  background-color: var(--color-bg-popup) !important;\n  color: var(--color-font-10) !important;\n}\n\n.paper_big {\n  min-width: 1000px;\n  max-width: 1000px !important;\n  overflow: visible;\n  min-height: 100px;\n  background-color: var(--color-bg-popup) !important;\n  color: var(--color-font-10) !important;\n}\n\n.paper::-webkit-scrollbar {\n  width: 8px !important;\n  display: inherit !important;\n  background-color: white !important;\n}\n\n.paper::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 0px !important;\n  display: inherit !important;\n  width: 10px !important;\n}\n.paper_big::-webkit-scrollbar {\n  width: 8px !important;\n  display: inherit !important;\n  background-color: white !important;\n}\n\n.paper_big::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 0px !important;\n  display: inherit !important;\n  width: 10px !important;\n}\n\n.popup_header {\n  text-transform: uppercase;\n  padding: 15px;\n  font-size: 18px;\n  font-weight: bold;\n  background-color: var(--color-bg-popup-header);\n}\n\n.popup_content {\n  padding: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `DialogPopup_paper__17-7M`,
	"paper_big": `DialogPopup_paper_big__P5tnN`,
	"popup_header": `DialogPopup_popup_header__epE+i`,
	"popup_content": `DialogPopup_popup_content__-xqz7`
};
export default ___CSS_LOADER_EXPORT___;
